import { Link } from "react-router-dom";
import { useCompany } from "@/lib/company";

const LOGOS = [
  ["vinti4", "/payment-logos/vinti4.png", "Vinti4"],
  ["visa", "/payment-logos/visa.svg", "Visa"],
  ["mastercard", "/payment-logos/mastercard.svg", "Mastercard"],
  ["amex", "/payment-logos/americanexpress.svg", "American Express"],
];
export const TOKEN_BRANDS = ["vinti4", "visa"];

export const fmtPlainCVE = (v) => `${Math.round(Number(v) || 0)} CVE`;

export function CardLogos({ className = "h-6", brands }) {
  return (
    <div className="flex items-center gap-2" data-testid="card-logos">
      {LOGOS.filter(([k]) => !brands || brands.includes(k)).map(([k, src, alt]) => (
        <span key={k} className="flex items-center justify-center rounded-md border border-slate-200 bg-white px-2 py-1">
          <img src={src} alt={alt} className={`${className} w-auto object-contain`} data-testid={`card-logo-${k}`} />
        </span>
      ))}
    </div>
  );
}

export function PayeeLine({ className = "" }) {
  const c = useCompany();
  if (!c.legal_name) return null;
  return (
    <div className={`text-xs ${className}`} data-testid="payee-line">
      Pagamento a favor de <b>{c.legal_name}</b> · NIF {c.nif}{c.email ? <> · <a href={`mailto:${c.email}`} className="underline">{c.email}</a></> : null}
    </div>
  );
}

export function PaymentFooter({ dark = false }) {
  const link = dark ? "text-white/70 hover:text-white" : "text-slate-500 hover:text-slate-900";
  return (
    <div className="flex flex-col items-center gap-3" data-testid="payment-footer">
      <CardLogos />
      <div className={`text-xs ${dark ? "text-white/60" : "text-slate-500"}`}>Pagamentos seguros: Cartão Vinti4 / Visa / Mastercard / Amex</div>
      <PayeeLine className={dark ? "text-white/60" : "text-slate-500"} />
      <div className="flex flex-wrap justify-center gap-4 text-xs">
        <Link to="/termos" className={link} data-testid="footer-terms-link">Termos</Link>
        <Link to="/privacidade" className={link} data-testid="footer-privacy-link">Privacidade</Link>
        <Link to="/politica-de-devolucao" className={link} data-testid="footer-refund-link">Política de Devolução</Link>
      </div>
    </div>
  );
}
